import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ActivityTypeEntity from '../entities/ActivityType.Entity';

export default function getActivityTypes(abortSignal: AbortSignal): Promise<Array<ActivityTypeEntity>> {   
    return apiGet<Array<ActivityTypeEntity>>('/activity-types',abortSignal);
}